import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _isEmpty from 'lodash/isEmpty';
import _toLower from 'lodash/toLower';
import _head from 'lodash/head';
import { EMPTY_OBJECT, EMPTY_ARRAY } from '../../app.constants'; // Constants

import { DEFAULT_PAGE_SIZE } from '../../constants/tableConstants'; // Helpers

import { getSortRequest, getTekScriptSortRequest } from './Request.helpers';
import GroupBy from './GroupBy';

var Request = /*#__PURE__*/function () {
  function Request() {
    var _this = this;

    _classCallCheck(this, Request);

    _defineProperty(this, "setKey", function (key) {
      _this.key = key;
      return _this;
    });

    _defineProperty(this, "setGroupBy", function (groupBy) {
      _this.groupBy = groupBy;
      return _this;
    });

    _defineProperty(this, "setProjections", function (projections) {
      _this.projections = projections;
      return _this;
    });

    _defineProperty(this, "addIncludeFields", function (includeFields) {
      _this.includeFields = [].concat(_toConsumableArray(_this.includeFields), _toConsumableArray(includeFields));
      return _this;
    });

    this.sort = [];
    this.filters = [];
    this.searchText = '';
    this.groupBy = [];
    this.includeFields = [];
    this.searchableFields = EMPTY_ARRAY;
    this.nextPageToken = undefined;
  }

  _createClass(Request, [{
    key: "addTekScriptSort",
    value: function addTekScriptSort(sortKey, sortOrder, sortIdOrCode) {
      var tekScriptSort = getTekScriptSortRequest(sortOrder, sortKey, sortIdOrCode);
      this.sort.push(tekScriptSort);
      return this;
    }
  }, {
    key: "addSort",
    value: function addSort(sortField, sortOrder) {
      var sort = getSortRequest(sortField, sortOrder);
      this.sort.push(sort);
      return this;
    }
  }, {
    key: "addFilter",
    value: function addFilter(field, operator, values, isCaseInsensitive) {
      var key = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : field;
      var extra = arguments.length > 5 ? arguments[5] : undefined;
      var params = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : EMPTY_OBJECT;
      // const filteredValues = _compact(values);
      var skipValueCheck = params.skipValueCheck,
          _params$isBooleanOper = params.isBooleanOperator,
          isBooleanOperator = _params$isBooleanOper === void 0 ? false : _params$isBooleanOper;

      if ((_isEmpty(values) || !operator) && !skipValueCheck) {
        return this;
      }

      if (isBooleanOperator) {
        this.filters.push(_objectSpread({
          operator: operator
        }, extra));
        return this;
      }

      this.filters.push(_objectSpread({
        field: isCaseInsensitive ? "".concat(field, ".text") : field,
        operator: operator,
        values: isCaseInsensitive ? [_toLower(_head(values))] : values,
        key: key
      }, extra));
      return this;
    }
  }, {
    key: "setPage",
    value: function setPage(page) {
      var pageSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_PAGE_SIZE;
      this.pageInfo = {
        start: page * pageSize,
        rows: pageSize
      };
      return this;
    }
  }, {
    key: "setNextPageToken",
    value: function setNextPageToken(nextPageToken) {
      this.pageInfo.start = 0;
      this.nextPageToken = nextPageToken;
      return this;
    }
  }, {
    key: "setSearchString",
    value: function setSearchString(searchQuery) {
      this.searchText = _toLower(searchQuery);
      return this;
    }
  }, {
    key: "setSearchableFields",
    value: function setSearchableFields(searchableFields) {
      this.searchableFields = searchableFields;
      return this;
    }
  }, {
    key: "setFilters",
    value: function setFilters(filters) {
      this.filters = filters;
      return this;
    }
  }, {
    key: "setSort",
    value: function setSort(sort) {
      this.sort = sort;
      return this;
    }
  }, {
    key: "addGroupBy",
    value: function addGroupBy(key, field, groupType, projections, rows, subGroups) {
      if (_isEmpty(key) && _isEmpty(field) && _isEmpty(groupType)) {
        return this;
      }

      this.groupBy.push(new GroupBy().setKey(key).setField(field).setGroupType(groupType).setProjections(projections).setRows(rows).setSubGroups(subGroups));
      return this;
    }
    /*
      Example for Using group by in request builder:
      "groupBy": [
          {
              "key": "customer.id",
              "field": "customer.id",
              "groupType": "FIELD",
              "projections": [
                  {
                      "key": "totalAmount",
                      "field": "saleAmount.amount",
                      "metricFunction": "SUM"
                  }
              ]
          }
      ]
    */

  }]);

  return Request;
}();

export default Request;